import { ChangeDetectionStrategy, Component, computed, input, model, signal } from '@angular/core';
import {
  ButtonDirective,
  FloatingMenuComponent,
  FloatingMenuItemComponent,
  MaterialIconComponent,
  NativeElementHook,
} from '@ps-gui/shared-core';
import { CheckboxComponent } from '@ps-gui/ui';
import { NgClass, NgOptimizedImage } from '@angular/common';
import { classByKey, DocumentClassKey } from '../../../document-classes/document-classes';

@Component({
  imports: [
    ButtonDirective,
    CheckboxComponent,
    FloatingMenuComponent,
    FloatingMenuItemComponent,
    MaterialIconComponent,
    NativeElementHook,
    NgOptimizedImage,
    NgClass,
  ],
  selector: 'ct-shared-document-class-filter',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './document-class-filter.component.html',
  styles: `
    .filter-btn {
      span {
        top: -5px;
        right: -5px;
      }
    }
  `,
})
export class DocumentClassFilterComponent {
  readonly availableDocumentClasses = input.required<string[]>();
  readonly growDirection = input<'right' | 'left'>('right');

  protected readonly crossOffset = computed(() => (this.growDirection() === 'right' ? 0 : -250));

  readonly appliedDocumentClasses = model.required<string[]>();

  protected readonly documentClassCheckboxes = computed(() => {
    return this.availableDocumentClasses().map((documentClass: string) => ({
      text: classByKey[documentClass as DocumentClassKey].label,
      value: documentClass,
      checked: signal(this.appliedDocumentClasses().includes(documentClass)),
    }));
  });

  readonly selectedDocumentClasses = computed(() =>
    this.documentClassCheckboxes()
      .filter((checkbox) => checkbox.checked())
      .map((checkbox) => checkbox.value),
  );

  readonly anyFilterApplied = computed(() =>
    this.availableDocumentClasses().some(
      (documentClass) => !this.appliedDocumentClasses().includes(documentClass),
    ),
  );

  readonly isOpen = signal(false);

  toggleFilterMenu(event: MouseEvent) {
    event.stopPropagation();
    this.isOpen.update((bool) => !bool);
  }

  onApplyFilter() {
    this.appliedDocumentClasses.set(this.selectedDocumentClasses());
    this.isOpen.set(false);
  }

  onResetFilterClicked() {
    this.documentClassCheckboxes().forEach((checkbox) => checkbox.checked.set(true));
    this.onApplyFilter();
  }

  hide() {
    this.isOpen.set(false);
  }
}
